var _defs, _path, _path2, _path3, _path4, _path5, _path6, _line;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBeautyEarthandPlanetElements12(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 180,
    height: 180,
    viewBox: "0 0 180 180",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n        stroke: #1e2220;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-width: 2.45px;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m87.29,35.1c-21.15,8.08-20.31,23.81-20.31,23.81,0,5.9,2.62,10.68,5.85,10.68s6.44-4.78,6.44-10.68c0,0-1.45-23.62-21.2-23.62-3.35,0-6.51.13-6.51,3.48v32.37c0,17.97,14.47,32.75,32.44,32.76h7.56c17.97,0,32.44-14.8,32.44-32.76v-32.37c0-3.35-3.17-3.48-6.51-3.48-19.75,0-21.2,23.62-21.2,23.62,0,5.9,3.2,10.68,6.44,10.68s5.85-4.78,5.85-10.68c0,0,.85-15.74-20.31-23.81h-.96Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m88.8,104.64v34.08c0,13.7-13.85,24.8-30.94,24.8h0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m129.65,112.19s-4.69,32.47-34.41,24.78c-3.46-.9-5.46-4.55-4.28-7.92,3.11-8.87,12.33-23.68,38.69-16.86Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m91.64,132.44s13.05-2.88,24.37-11.91"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m70.86,81.71s2.46,10.06,9.24,11.71"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m107.01,81.71s-2.46,10.06-9.24,11.71"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 88.93,
    y1: 76.57,
    x2: 88.93,
    y2: 93.41
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBeautyEarthandPlanetElements12);
export default __webpack_public_path__ + "static/media/Beauty, Earth and Planet Elements-12.f3e2772c8a1da4a34694671b40a3e763.svg";
export { ForwardRef as ReactComponent };